import React from "react";
import {Link} from "react-router-dom";

export default function ResultCard({resultItem, remoteApiUrlBase}) {

  const imgRoute = remoteApiUrlBase + "/api/File/";

  // console.log(resultItem);

  return (
    <Link className="r-item" id={resultItem.uri} to={`/detail/${resultItem.uri}`} detailitem={resultItem}>

      {resultItem.img &&
        <figure>
          <img className="r-img" src={`${imgRoute}${resultItem.img}`} alt="Imagen"/>
          {/*{resultItem.RightHolder && <figcaption>&copy; {resultItem.RightHolder}</figcaption>}*/}
          {/*{resultItem.License && <figcaption>Llicencia: {resultItem.License}</figcaption>}*/}
        </figure>
      }

      <div className="r-content">
        {resultItem?.metadata?.map(
          (metadata, j) =>
            (resultItem.metadata[j].type === "Fons" || resultItem.metadata[j].type === "Expedient/dossier") && (
              <div className="r-type" key={j} id={resultItem.metadata[j].uri}>
                <strong>
                  {resultItem.metadata[j].type}
                  {": "}
                </strong>
                {resultItem.metadata[j].value}
              </div>
            )
        )}
        <div className="r-cat">{resultItem.type}</div>
        {resultItem?.metadata?.map(
          (metadata, i) =>
            resultItem.metadata[i].type === "Referència" && (
              <div className="r-ref" key={i}>
                Ref. {resultItem.metadata[i].value}
              </div>
            )
        )}
        <div className="r-name">{resultItem.name}</div>
      </div>
    </Link>
  );
}
